<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        class="my-1 text-none"
        v-bind="attrs"
        v-on="on"
        rounded
      >
        <v-icon left> mdi-plus </v-icon>
        Nueva Empresa
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-body-1 primary--text">Nueva Empresa</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <validation-alert :validationErrors="validationErrors" />
          <v-form ref="form" v-model="isValidFormDialog" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedItem.name"
                  :rules="nameRules"
                  label="Nombre"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedItem.society"
                  :rules="societyRules"
                  label="Sociedad"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey lighten-1" text @click="close()"> Cancelar </v-btn>
        <v-btn
          color="blue"
          :loading="isLoading"
          :disabled="isLoading"
          text
          @click="save()"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationAlert from "@/components/global/ValidationAlert.vue";
import { maxlength, isRequired } from "@/assets/js/validations";
import { $EventBus } from "@/main";
export default {
  name: "CreateCompanyDialog",

  props: {},

  data: () => ({
    dialog: false,
    isValidFormDialog: false,
    isLoading: false,
    nameRules: [(v) => isRequired(v), (v) => maxlength(v, 255)],
    societyRules: [(v) => isRequired(v), (v) => maxlength(v, 255)],
    editedItem: {
      name: "",
      society: "",
    },
    defaultItem: {
      name: "",
      society: "",
    },
  }),

  computed: {
    validationErrors() {
      return this.$store.getters["companies/getValidationErrors"];
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.$store.dispatch("companies/cleanValidationErrors");
        this.$refs.form.resetValidation();
      });
    },

    showSnack(color = "green", text = "") {
      $EventBus.$emit("showSnack", { color, text });
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        const data = {
          name: this.editedItem.name,
          society: this.editedItem.society,
        };
        try {
          await this.$store.dispatch("companies/saveCompany", data);
          this.showSnack("green", "Se ha registrado satisfactoriamente");
          this.$emit("resetFilter");
          this.close();
        } catch (error) {}
        this.isLoading = false;
      }
    },
  },
  components: {
    ValidationAlert,
  },
};
</script>
